export default "__VITE_ASSET__5d9cf5c7__"